/* eslint-disable camelcase */
export type WarehouseReviewDecisionCode = { decision_code?: string | null }

export type WarehouseReviewItem = {
  disabled?: boolean | null
  deleted?: boolean | null
  delivered_warehouse?: boolean | null
}

export const requiresWarehouseReview = (decision?: WarehouseReviewDecisionCode | null): boolean => decision?.decision_code?.startsWith('REVISAR') ?? true

export const hasUncheckedWarehouseReviewItems = (decision: WarehouseReviewDecisionCode | null | undefined, items: WarehouseReviewItem[]): boolean => {
  if (!requiresWarehouseReview(decision)) return false
  return items.filter((item) => !item.disabled && !item.deleted).some((item) => !item.delivered_warehouse)
}
